﻿$.fn.dxCtrlSelectEmailFileHeberge = function custom_dxCtrlSelectEmailFileHeberge(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlselectemailfileheberge dx-ctrl");
        this.createInstance(new cdxCtrlSelectEmailFileHeberge(this, option));
    }
    return this;
}

window.cdxCtrlSelectEmailFileHeberge = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dx = null
    function mConstruit() {
        container.empty();
        var ds = [{
            nom: "Sélectionner un nouveau fichier",
            url: ""
        }]
        option.lstfileheberge.forEach(function (url) {
            var nom = url.substring(url.lastIndexOf("/") + 1)
            ds.push({
                nom: nom,
                url: url
            })
        })

        var dxBtVisu = null
        var dxBtDel = null
        var disableSelectionChanged = false
        $("<div/>").appendTo(container).dxCtrlSelectBox({
            labelMode: 'floating',
            label: "Fichier",
            displayExpr: "nom",
            placeholder: "(Aucun fichier)",
            dataSource: ds,
            selectedItem: ds.filter(function (o) { return o.nom == option.currentNomFileSelected })[0],
            itemTemplate(itemData, itemIndex, itemElement) {
                if (itemIndex == 0) { itemElement.css("font-style", "italic") }
                else { itemElement.css("font-weight", "bold") }
                itemElement.text(itemData.nom)
            },
            value: ds.filter(function (o) { return o.nom == option.currentNomFileSelected })[0],
            onSelectionChanged: function (e) {
                if (disableSelectionChanged || e.selectedItem == null) return
                if (e.selectedItem.url.length == 0) {
                    disableSelectionChanged = true
                    option.currentNomFileSelected = null
                    option.onValueChanged({ value: null })
                    dxBtVisu.option("disabled", true)
                    dxBtDel.option("disabled", true)
                    e.component.option("value", null)
                    disableSelectionChanged = false
                    $("<div/>").appendTo("body").dxCtrlFileUploaderPopup({
                        bddCtrl: option.bddCtrl,
                        multiple: false,
                        machine: true,
                        imgInternet: false,
                        box: true,
                        icone: false,
                        docCpt: false,
                        courrier: false,
                        camera: false,
                        selectedItem: "machine",
                        optionUploader: {
                            bddCtrl: option.bddCtrl,
                            maxFileSize: 20971520, //20Mo
                        },
                        onValide: function (lstUrlFile) {
                            if (lstUrlFile.length > 0) {
                                var newUrlFile = lstUrlFile[0]
                                var newNom = newUrlFile.substring(newUrlFile.lastIndexOf("/") + 1)
                                var oldData = ds.filter(function (o) { return o.nom == newNom })[0]
                                option.currentNomFileSelected = newNom
                                if (typeof oldData == 'undefined') {
                                    //nouveau fichier
                                    option.lstfileheberge.push(newUrlFile)
                                    oldData = {
                                        nom: newNom,
                                        url: newUrlFile
                                    }
                                    ds.push(oldData)
                                } else {
                                    //modif fichier existant
                                    option.lstfileheberge[option.lstfileheberge.indexOf(oldData.url)] = newUrlFile
                                    oldData.url = newUrlFile
                                }
                                e.component.option({
                                    dataSource: ds,
                                    selectedItem: oldData,
                                    value: oldData
                                })
                                //option.onValueChanged({ value: oldData })
                            }
                        }
                    }).dxCtrlFileUploaderPopup("instance")
                } else {
                    option.currentNomFileSelected = e.selectedItem.nom
                    option.onValueChanged({ value: e.selectedItem })
                    if (typeof dxBtVisu != 'undefined' && dxBtVisu != null) dxBtVisu.option("disabled", false)
                    if (typeof dxBtDel != 'undefined' && dxBtDel != null) dxBtDel.option("disabled", false)
                }
            },
            buttons: [{
                focusStateEnabled: false,
                name: 'visu',
                location: 'after',
                options: {
                    icon: 'fas fa-eye',
                    stylingMode: 'text',
                    hint: "Visualiser/télécharger le fichier",
                    disabled: (option.currentNomFileSelected == null),
                    onClick() {
                        if (option.currentNomFileSelected != null) {
                            var currentData = ds.filter(function (o) { return o.nom == option.currentNomFileSelected })[0]
                            if (typeof currentData != 'undefined') {
                                var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                    fullScreen: true,
                                    showTitle: false,
                                    contentTemplate: function (contentElement) {
                                        contentElement.css("position", "relative")
                                        dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:5px'/>").appendTo(contentElement).dxCtrlButton({
                                            icon: 'fas fa-times',
                                            width: HeightButton,
                                            height: HeightButton,
                                            onClick: function (e) {
                                                popup.hide()
                                            }
                                        }).dxCtrlButton("instance");

                                        var $Div = $("<div style='width:100%;height:100%;'/>").appendTo(contentElement)
                                        $("<div/>").appendTo($Div).dxCtrlViewer({
                                            value: currentData.url,
                                            autoriseModif: false,
                                            inPopup: false,
                                            bddCtrl: option.bddCtrl
                                        }).dxCtrlViewer("instance")
                                    },
                                    onShown: function (e) {
                                    },
                                    onHiding: function (e) {
                                    }
                                }).dxCtrlPopupBase("instance")
                                popup.show()
                            }
                        }
                    },
                    onContentReady: function (e) {
                        dxBtVisu = e.component
                    }
                }
            }, {
                focusStateEnabled: false,
                name: 'del',
                location: 'after',
                options: {
                    icon: 'fas fa-delete-left fa-rotate-270',
                    hint: "Retirer le fichier de l'ensemble du message<br/>et annuler tous les liens sur ce fichier",
                    stylingMode: 'text',
                    disabled: (option.currentNomFileSelected == null),
                    onClick() {
                        option.onDelete({ value: option.currentNomFileSelected })
                        option.currentNomFileSelected = null;
                        mConstruit()
                    },
                    onContentReady: function (e) {
                        dxBtDel = e.component
                    }
                },
                }],
            onContentReady: function (e) {
                e.component.element().find("input").attr("title", "Choisissez un fichier à afficher au moment du click sur l'élément<br/>(20Mo maximum. Au-delà de cette taille, choisissez un fichier dans votre box.<br/>Ce fichier sera affiché si le navigateur l'autorise (vidéo, pdf, image) ou téléchargé au moment du click.")
            }
        })


        //var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        //var dxBtVisu = $("<div/>").appendTo($Td).dxCtrlButton({
        //    icon: "fas fa-eye",
        //    txtTooltip: "Voir le fichier",
        //    disabled: (option.currentNomFileSelected == null),
        //    onClick: function (e) {
        //        if (option.currentNomFileSelected != null) {
        //            var currentData = ds.filter(function (o) { return o.nom == option.currentNomFileSelected })[0]
        //            if (typeof currentData != 'undefined') {
        //                var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
        //                    fullScreen: true,
        //                    showTitle: false,
        //                    contentTemplate: function (contentElement) {
        //                        contentElement.css("position", "relative")
        //                        dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:5px'/>").appendTo(contentElement).dxCtrlButton({
        //                            icon: 'fas fa-times',
        //                            width: HeightButton,
        //                            height: HeightButton,
        //                            onClick: function (e) {
        //                                popup.hide()
        //                            }
        //                        }).dxCtrlButton("instance");

        //                        var $Div = $("<div style='width:100%;height:100%;'/>").appendTo(contentElement)
        //                        $("<div/>").appendTo($Div).dxCtrlViewer({
        //                            value: currentData.url,
        //                            autoriseModif: false,
        //                            inPopup: false,
        //                            bddCtrl: option.bddCtrl
        //                        }).dxCtrlViewer("instance")
        //                    },
        //                    onShown: function (e) {
        //                    },
        //                    onHiding: function (e) {
        //                    }
        //                }).dxCtrlPopupBase("instance")
        //                popup.show()
        //                //option.bddCtrl.getObjet("fichier", currentData.url).mShowPopup({ width: 600,readOnly:true });
        //                ////page.mAddPopup({
        //                ////    id_fichier: currentData.url
        //                ////}, { fullScreen: true })
        //            }
        //        }
        //    }
        //}).dxCtrlButton("instance")
    }

    this.element = function () { return container }
    this.focus = function () { dx.focus() }

    mConstruit();
}